export default __webpack_public_path__ + "static/media/提示.8f339aa4.svg";